import { FlowState } from "./types";
import { defineStore } from "pinia";

export const useFlowStore = defineStore("flow", {
  state: (): FlowState => ({
    data: {},
    answered: {},
    active: false,
    signedIn: false
  }),
  actions: {
    setData(data: any) {
      this.data = data;
    },
    updateData({ key, value }: { key: string; value: any }) {
      this.data[key] = value;
    },
    setState({ newState, clearData }: { newState: any; clearData: boolean }) {
      if (clearData) {
        this.$patch({
          ...newState,
          data: {},
          answered: {}
        });
      } else {
        const copy = { ...newState };
        delete copy.data;
        delete copy.answered;
        this.$patch(copy);
      }
    },
    setActive(active: boolean) {
      this.active = active;
    },
    setAnswered({ key, value }: { key: string; value: any }) {
      this.answered[key] = value;
    }
  }
});
